/*
 * @Date         : 2021-05-13 15:40:33
 * @LastEditors  : cxx
 * @LastEditTime : 2021-05-18 10:37:35
 * @FilePath     : \web-mall\src\static\app\js\lib\request.js
 */
import Request from "axios";
import _ from "underscore";
import qs from "querystring";
import cookie from "./cookie";
import CONSTANT from "../constant/cookie";
import { getCustomizedHeader } from "../util/x_client_info";
import { logout } from "../util/function";

const addKey = (url) => {
  const h = url.split("?")[0];
  const p = qs.parse(url.split("?")[1]);
  p.k = _.random(0, 10000000);
  return [h, qs.stringify(p)].join("?");
};

const Api = Request.create({
  headers: { "X-Requested-With": "XMLHttpRequest" },
  timeout: 15000,
  transformRequest: [
    (data) => {
      return data;
    },
  ],
  transformResponse: [
    (data) => {
      if (!data) {
        throw new Error("unexpect server error");
      }
      return data;
    },
  ],
});

Api.interceptors.request.use((config) => {
  const ret = _.assign({}, config, {
    url: !config.noKey ? addKey(config.url) : config.url,
    headers: _.assign({}, config.headers, {
      "X-Client-Info": JSON.stringify(
        _.assign({}, getCustomizedHeader(), config.headers["X-Client-Info"])
      ),
    }),
  });
  return ret;
});

Api.interceptors.response.use(
  (response) => {
    // 将系统时间保存在本地
    cookie(CONSTANT.COOKIE_SERVICE_TIME, response.headers["x-time"] || "");
    if (response.status === 200) {
      const res = JSON.parse(response.data);
      if (res.status === 6666 && res.msg === "请重新登陆") {
        logout(true);
      }
      return JSON.parse(response.data);
    }
    throw "服务器开小差~请稍后再试";
  },
  (e) => {
    console.log(e);
    throw "网络开小差～，刷新试试";
  }
);

export default Api;
